<template>
  <Testimonial
    v-if="testimonialData"
    :testimonial-data="testimonialData"
  />
</template>

<script lang="ts" setup>
import Testimonial from './Testimonial.vue';
import type { PortableTextTestimonial } from '~/sanity/types';
import { useRefsStore } from '~/composables/refsStore';

const props = defineProps<PortableTextTestimonial>();

const { getResolvedTestimonial } = useRefsStore();

const testimonialData = await getResolvedTestimonial(
  props.testimonial?.testimonial?.reference?._ref
);
</script>

<style></style>
